import React, { ReactElement } from 'react';
import { AnalyticsButton } from '@shootsta/common-react';
import cx from 'classnames';
import { isLightColor } from '../../../../../utils';
import AnalyticsTypes from '../../../../../../../constants/AnalyticsTypes';

import './styles/_cta-button.scss';

interface CtaButtonProps {
  shareablePageId: string;
  cta: string;
  ctaLinkUrl: string;
  color?: string;
  createAnalyticsEntry?: (analyticsType: AnalyticsTypes) => void;
  transparent?: boolean;
}

export default function CtaButton({
  shareablePageId,
  cta,
  ctaLinkUrl,
  color,
  createAnalyticsEntry,
  transparent = false,
  ...rest
}: CtaButtonProps): ReactElement {
  const hasLightBackground = color && !transparent && isLightColor(color);
  const buttonStyles = (color && !transparent)
    ? { backgroundColor: color }
    : {
      borderColor: color,
      color
    };

  const textStyles = transparent
    ? { color }
    : undefined;

  return (
    <AnalyticsButton
      createAnalyticsEntry={createAnalyticsEntry}
      analyticsResourceId={shareablePageId}
      analyticsType={AnalyticsTypes.CTA_CLICK}
      linkUrl={ctaLinkUrl}
      className={cx(
        'cta-button',
        {
          'cta-button--transparent': transparent
        }
      )}
      style={buttonStyles}
      {...rest}
    >
      <span
        className={cx(
          'cta-button__text',
          {
            'cta-button--transparent__text': transparent,
            'cta-button__text--dark': hasLightBackground
          }
        )}
        style={textStyles}
      >
        {cta}
      </span>
    </AnalyticsButton>
  );
}
